import "../css/index.css"

import initHeader from "../../../app/modules/Front/components/Header/Header.js"
import initVideo from "../../../app/modules/Front/components/Video/Video.js"
import initKaraoke from "../../../app/modules/Front/components/Karaoke/Karaoke.js"
import initSpotlight from "../../../app/modules/Front/components/Spotlight/Spotlight.js"
import initTenantsPie from "../../../app/modules/Front/components/TenantsPie/TenantsPie.js"
import initSwiper from "../../../app/modules/Front/components/Swiper/swiper.js"
import initContact from "../../../app/modules/Front/components/ContactToggle/ContactToggle.js"
import initTabs from "../../../app/modules/Front/components/Tabs/Tabs.js"
import initHeroAnim from "../../../app/modules/Front/components/HeroAnim/HeroAnim.js"
import initHeroHp from "../../../app/modules/Front/components/HeroHp/HeroHp.js"
import initPortfolioParks from "../../../app/modules/Front/components/PortfolioParks/PortfolioParks.js"
import initLeadForm from "../../../app/modules/Front/components/LeadForm/LeadForm.js"
import initChart from "../../../app/modules/Front/components/Chart/Chart"
import initIconInfo from "../../../app/modules/Front/components/IconInfo/IconInfo.js"
import initSection from "../../../app/modules/Front/components/Section/Section.js"
import initFlashMessages from "../../../app/modules/Front/components/FlashMessages/FlashMessages.js"
import intiCookiesConsent from "../../../app/modules/Front/components/CookieConsent/CookieConsent.js"
import initScrollToTopButton from "../../../app/modules/Front/components/ScrollToTopButton/ScrollToTopButton"
import initLottie from "./lottie.js"
import initFundSlider from "../../../app/modules/Front/components/FundSlider/FundSlider"
import initAlpine from "./alpine"

initAlpine()

window.addEventListener(`DOMContentLoaded`, () => {
  initHeader()
  initSwiper()
  initVideo()
  initSpotlight()
  initTenantsPie()
  initHeroHp()
  initContact()
  initTabs()
  // initHeroAnim()
  initPortfolioParks()
  initKaraoke()
  initLeadForm()
  initChart()
  initIconInfo()
  initSection()
  intiCookiesConsent()
  initFlashMessages()
  initScrollToTopButton()
  initFundSlider()

  console.log("DOM loaded")
})

window.addEventListener("load", () => {
  initLottie()

  console.log("page loaded")
})
